import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.css';
import { Container, Row } from 'reactstrap';
import { ModalBody, ModalHeader } from 'reactstrap';
import SignUpForm from '../../components/elements/forms/SignUpForm';
import { IS_SIDEKICK_APP } from '../../constants/projects';

const SignUpPage = () => {
    return (
        <Container
            className={classNames('unauthorized-signup__container', {
                'unauthorized-signup__container--sidekick': IS_SIDEKICK_APP,
            })}
        >
            <Row className="unauthorized-signup">
                <h5 className="unauthorized-signup-title">Sign up, it's completely FREE!</h5>
                <div>
                    <SignUpForm />
                </div>
            </Row>
        </Container>
    );
};

SignUpPage.propTypes = {};

export default React.memo(SignUpPage);
